import { render, staticRenderFns } from "./BaseTradeInVoucherSelectionItem.vue?vue&type=template&id=36f40dc3&scoped=true"
import script from "./BaseTradeInVoucherSelectionItem.vue?vue&type=script&lang=js"
export * from "./BaseTradeInVoucherSelectionItem.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInVoucherSelectionItem.vue?vue&type=style&index=0&id=36f40dc3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f40dc3",
  null
  
)

export default component.exports